import { Component, OnInit } from '@angular/core';

import { AuthService } from '../shared/auth.service';

@Component({
    selector: 'app-auth-token',
    template: '<div>Receiving auth token ...</div>'
})
export class AuthTokenComponent implements OnInit {
    constructor(private readonly authService: AuthService) {

    }

    public ngOnInit(): void {
        this.authService.redirectToLastPage();
    }
}
